WB.Routing = WB.Routing ||{};

//
// Custom route provider to extend the baked-in angular functionality
//

WB.Routing.ResolveMetadata = function(options) {
    return [
        'RoutingHistory', '$q', 'Metadata', 'MetadataDataManager',
        function(RoutingHistory, $q, Metadata, MetadataDataManager) {

            // Don't grab metadata if there's no history
            if (RoutingHistory.all().length == 0) {
                return null;
            }

            return $q(function(resolve, reject) {
                MetadataDataManager.GetMetadataForUrl().then(function(metadata) {
                    Metadata.set(metadata);
                    resolve(metadata);
                });
            });

        }
    ];
};

WB.Routing.Provider = function($routeProvider) {

    var _this = this;

    var valueFn = function(val) {
        return function() {
            return val;
        };
    };

    this.when = function(url, options) {

        // Required parameters
        ['name', 'controller'].forEach(function(datum) {
            if (!options[datum]) {
                throw Error('Route [' + url + '] must have a [' + datum + '] property.');
            }
        });

        var resolve = {};

        // Attach any options as locals (resolvers)
        // If injection provided, attach those directly
        for (var key in options) {
            if (options.hasOwnProperty(key)) {
                var isInjection = angular.isArray(options[key]) && angular.isFunction(options[key][options[key].length - 1]);
                resolve[key] = isInjection ? options[key] : valueFn(options[key]);
            }
        }

        // Resolve metadata on every request. This is important and needed
        // before we continue with anything else in the route
        resolve.metadata = WB.Routing.ResolveMetadata(options);

        $routeProvider.when(url, {
            resolve: resolve,
            reloadOnSearch: false
        });

        return _this;
    };

    this.$get = angular.noop;

};
WB.Routing.Provider.$inject = ['$routeProvider'];
WB.App.provider('wbRoute', WB.Routing.Provider);